import { Button, Col, Row, Input } from "antd";
const { Search } = Input;

const FilterMenu = (props) => {
  const onSearch = (value) => props.onSearch(value);
  const onClear = (value) => props.onClear(value);

  return (
    <Row
      align="middle"
      style={{ marginBottom: "18px" }}
      justify={"end"}
      gutter={[8, 8]}
    >
      <Col xl={4} lg={5} md={6} sm={8} xs={24}>
        <Search
          placeholder="Input Name"
          allowClear
          onSearch={onSearch}
          style={{ width: "100%" }}
          onClear={onClear}
        />
      </Col>
      <Col xl={2} lg={3} md={4} sm={6} xs={24}>
        <Button
          type="primary"
          onClick={() => props.onShowAdd(true)}
          style={{ width: "100%" }}
        >
          Add Pallet
        </Button>
      </Col>
      <Col xl={2} lg={3} md={4} sm={6} xs={24}>
        <Button
          type="primary"
          onClick={() => props.onShowImport(true)}
          style={{ width: "100%", backgroundColor: "#4cb050" }}
        >
          Import
        </Button>
      </Col>
    </Row>
  );
};

export default FilterMenu;
